import { AirportConfigurationType } from '../../../../../backend';
import { ConfigurationFieldsLineAirlines } from './ConfigurationFieldsLineAirlines';

export const ComponentByType: Record<
    AirportConfigurationType,
    React.FC<{
        index: number;
        arrayReplace: (index: number, value: any) => void;
    }>
> = { [AirportConfigurationType.AIRLINES]: ConfigurationFieldsLineAirlines };
